module.exports = __webpack_public_path__ + "img/90.a1e0810d.png";